<template>
  <div>
    <QS-h4-title slot="header" title="套餐商品" />
    <div v-for="combo in packageList" :key="combo.id">
      <el-descriptions  :column="1" border>
        <el-descriptions-item :labelStyle="{width:'120px',borderBottom:'none'}"  :contentStyle="{borderBottom:'none',fontWeight:500,color:'#303133'}" v-for="description in comboList.slice(0,1)" :label="description.label" :key="description.label">{{ combo[description.value] }} <el-tag class="package-type-name" type="success"> {{ combo.packageTypeName }}</el-tag></el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3" border>
        <el-descriptions-item :labelStyle="{width:'120px'}" v-for="description in comboList.slice(1)" :label="description.label" :key="description.label">{{ combo[description.value] }}</el-descriptions-item>
      </el-descriptions>
      <QS-common-table
        v-for="(offItem) in combo.packageUseList"
        class="custom-table"
        :key="offItem.offId"
        :data="offItem.goodsList"
        :pagination="false"
        :columns="planConfigData.tableData.columns"
        :span-method="(row)=>objectSpanMethod(row,offItem.goodsList)"
        :cell-class-name="setClass"
        >
        <template  slot="operation-group">
          <span class="off-item-name">
            {{offItem.name}}
          </span>
        </template>
      </QS-common-table>
    </div>
  </div>
</template>

<script>
import config from '../../config'
import mixins from '../../mixins/maintenancePlan'

const { comboList } = config
export default {
  name: 'comboProduct',
  props: ['packageList'],
  mixins: [mixins],
  data() {
    return {
      comboList,
    }
  },
  methods: {
    // 合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }, goodsList) {
      if (columnIndex === 5) {
        return {
          rowspan: goodsList.length,
          colspan: 1,
        }
      }
    },

    // 设置列的样式
    setClass({ columnIndex }) {
      if (columnIndex === 5) {
        return 'work-amount'
      }
    },
  },
}
</script>

<style lang="scss">
#app .el-table tbody tr .work-amount{
  border-left: solid 1px #EBEDF0 !important;
  border-bottom:  none !important;
}
</style>
<style lang="scss" scoped>
.off-item-name{
  font-weight: 500;
  color: #323233;
}
.package-type-name{
  margin-left:10px;
  font-size:10px
}
 </style>
